import React, { useState } from 'react';

const PROPERTY_CLASS = {
  "It's Happy Hour": 'property-happy-hour',
  '4400 Windswept': 'property-windswept',
};

export default function TaskCard({ task, photos = [], onToggle, onEdit, onDelete }) {
  const [showLightbox, setShowLightbox] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const today = new Date().toISOString().split('T')[0];
  const isOverdue = !task.done && task.due_date && task.due_date < today;
  const propClass = PROPERTY_CLASS[task.properties?.name] || '';

  const formatDate = (d) => {
    if (!d) return null;
    const date = new Date(d + 'T12:00:00');
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const openLightbox = (e, index) => {
    e.stopPropagation();
    setLightboxIndex(index);
    setShowLightbox(true);
  };

  const closeLightbox = (e) => {
    e.stopPropagation();
    setShowLightbox(false);
  };

  return (
    <>
      <div
        className={`task-card ${propClass} priority-${task.priority} ${task.done ? 'done' : ''}`}
        onClick={() => onEdit(task)}
      >
        {/* Checkbox */}
        <div
          className={`task-checkbox ${task.done ? 'checked' : ''}`}
          onClick={e => { e.stopPropagation(); onToggle(task); }}
        >
          {task.done && '\u2713'}
        </div>

        {/* Body */}
        <div className="task-body">
          <div className="task-title">{task.title}</div>
          <div className="task-meta">
            {task.properties?.name && (
              <span className={`tag ${propClass ? `tag-${propClass}` : 'tag-property'}`}>{task.properties.name}</span>
            )}
            {task.priority && (
              <span className={`tag tag-priority-${task.priority}`}>{task.priority}</span>
            )}
            {task.vendor && (
              <span className="tag tag-vendor">{task.vendor}</span>
            )}
            {task.assigned_to && (
              <span className="tag tag-vendor" title="Assigned to">👤 {task.assigned_to}</span>
            )}
            {task.cost > 0 && (
              <span className="tag tag-cost">${parseFloat(task.cost).toLocaleString()}</span>
            )}
            {task.due_date && (
              <span className={`tag ${isOverdue ? 'tag-overdue' : 'tag-due'}`}>
                {isOverdue ? 'Overdue \u00b7 ' : ''}{formatDate(task.due_date)}
              </span>
            )}
            {task.is_recurring && (
              <span className="tag tag-recurring">🔁 {task.recurrence_interval}</span>
            )}
            {photos.length > 0 && (
              <span className="tag tag-photos" onClick={e => openLightbox(e, 0)}>
                📷 {photos.length}
              </span>
            )}
          </div>
          {task.notes && (
            <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>{task.notes}</div>
          )}

          {photos.length > 0 && (
            <div className="task-photo-row" onClick={e => openLightbox(e, 0)}>
              <img
                className="task-thumbnail"
                src={photos[0].url}
                alt={photos[0].filename || 'Task photo'}
              />
              {photos.length > 1 && (
                <span className="task-photo-more">+{photos.length - 1} more</span>
              )}
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="task-actions" onClick={e => e.stopPropagation()}>
          <button className="icon-btn" onClick={() => onEdit(task)} title="Edit">Edit</button>
          <button className="icon-btn delete" onClick={() => onDelete(task.id)} title="Delete">Delete</button>
        </div>
      </div>

      {/* Lightbox */}
      {showLightbox && photos.length > 0 && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>&times;</button>
            <img
              className="lightbox-image"
              src={photos[lightboxIndex].url}
              alt={photos[lightboxIndex].filename || 'Photo'}
            />
            {photos.length > 1 && (
              <div className="lightbox-nav">
                <button
                  className="lightbox-arrow"
                  onClick={() => setLightboxIndex((lightboxIndex - 1 + photos.length) % photos.length)}
                >&lsaquo;</button>
                <span className="lightbox-counter">
                  {lightboxIndex + 1} of {photos.length}
                </span>
                <button
                  className="lightbox-arrow"
                  onClick={() => setLightboxIndex((lightboxIndex + 1) % photos.length)}
                >&rsaquo;</button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
